import { IUserModel, IUserProfilePictureModel, IUserProfileData } from "./model/IUserModel";
import { DefaultResult, Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class UserService extends ServiceBase {


    public async modifyUserProfile(userPutModel: IUserModel): Promise<DefaultResult> {

        const url = `/User/${userPutModel.userId?.value}/Profile`; 

        const result = await this.requestJson({
            url: url,
            method: "PUT",
            data: userPutModel,
        });

        return result;
    }

    public async updateUserProfilePicture(profilePictureModel: IUserProfilePictureModel): Promise<DefaultResult> {
        const url = `/User/${profilePictureModel.userId}/Profile/Picture`;

        const formData = new FormData();
        formData.append("file", profilePictureModel.file);

        const result = await this.sendFormData({
            url: url,
            method: "PUT",
            data: formData,
        });
        return result;
    }

    public async getProfilePictureFile(
        userId: string,
        width: number,
        height: number,
    ): Promise<Result<Blob>> {
        let url = `/User/${userId}/Profile/Picture?width=${width}&height=${height}`;

        var result = await this.requestFile<Blob>({
            url: url,
            method: "GET",
        });

        return result;
    }

    public async getProfileData(
        userId: string,
    ): Promise<Result<IUserProfileData>> {
        let url = `/User/${userId}/Profile`;

        var result = await this.requestJson<IUserProfileData>({
            url: url,
            method: "GET",
        });
        return result;
    }
}
